import React, { useEffect, useState } from 'react';
import axios from 'axios';
import SellerLayout from './SellerLayout';

const SellerDeliverySetting = () => {
  const [loading, setLoading] = useState(true);
  const [shopId, setShopId] = useState(null);
  const [shopName, setShopName] = useState('');
  const [deliveryEnabled, setDeliveryEnabled] = useState(false);
  const [successMsg, setSuccessMsg] = useState('');
  const [errorMsg, setErrorMsg] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get('/api/seller/delivery-setting/data', {
          withCredentials: true,
        });

        if (!res.data || res.data.ok !== true) {
          alert((res.data && res.data.msg) || '불러오기 실패');
          window.location.href = '/seller/manage';
          return;
        }

        setShopId(res.data.shop_id ?? null);
        setShopName(res.data.shop_name || '');
        setDeliveryEnabled(Number(res.data.delivery_enabled || 0) === 1);
      } catch (err) {
        console.error(err);
        alert('불러오기 실패');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleSave = async (e) => {
    e.preventDefault();
    setSuccessMsg('');
    setErrorMsg('');

    try {
      const fd = new FormData();
      if (deliveryEnabled) {
        fd.append('delivery_enabled', '1');
      }

      const res = await axios.post('/api/seller/delivery-setting/save', fd, {
        withCredentials: true,
      });

      if (!res.data || res.data.ok !== true) {
        setErrorMsg((res.data && res.data.msg) || '저장 실패');
        return;
      }

      setSuccessMsg(res.data.msg || '설정이 저장되었습니다.');
    } catch (err) {
      console.error(err);
      setErrorMsg('저장 실패');
    }
  };

  if (loading) {
    return (
      <SellerLayout shopName={shopName}>
        <div style={styles.loading}>불러오는 중...</div>
      </SellerLayout>
    );
  }

  return (
    <SellerLayout shopName={shopName}>
      <div style={styles.container}>
        <h2 style={styles.title}>🚚 배달 수령 설정</h2>

        {successMsg ? (
          <div style={styles.successAlert}>{successMsg}</div>
        ) : null}

        {errorMsg ? (
          <div style={styles.errorAlert}>{errorMsg}</div>
        ) : null}

        <div style={styles.card}>
          <div style={styles.cardBody}>
            <div style={styles.shopRow}>
              <strong>가게명:</strong> {shopName}
            </div>

            <form onSubmit={handleSave}>
              <div style={styles.switchRow}>
                <div className="form-check form-switch mb-4" style={{ marginBottom: 0 }}>
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="delivery_enabled"
                    name="delivery_enabled"
                    checked={deliveryEnabled}
                    onChange={(e) => setDeliveryEnabled(e.target.checked)}
                    style={styles.switchInput}
                  />
                  <label
                    className="form-check-label fw-bold"
                    htmlFor="delivery_enabled"
                    style={styles.switchLabel}
                  >
                    배달 주문 받기
                  </label>
                </div>
              </div>

              <button type="submit" style={styles.primaryBtn}>
                저장하기
              </button>
            </form>
          </div>
        </div>
      </div>
    </SellerLayout>
  );
};

const styles = {
  loading: {
    padding: '40px 0',
  },
  container: {
    marginTop: '16px',
    maxWidth: '520px',
  },
  title: {
    marginBottom: '24px',
  },
  successAlert: {
    marginBottom: '16px',
    padding: '12px 14px',
    border: '1px solid #badbcc',
    background: '#d1e7dd',
    color: '#0f5132',
    borderRadius: '8px',
  },
  errorAlert: {
    marginBottom: '16px',
    padding: '12px 14px',
    border: '1px solid #f5c2c7',
    background: '#f8d7da',
    color: '#842029',
    borderRadius: '8px',
  },
  card: {
    border: '1px solid #dee2e6',
    borderRadius: '10px',
    boxShadow: '0 .125rem .25rem rgba(0,0,0,.075)',
    background: '#fff',
  },
  cardBody: {
    padding: '20px',
  },
  shopRow: {
    marginBottom: '20px',
    fontSize: '15px',
  },
  switchRow: {
    marginBottom: '20px',
  },
  switchInput: {
    cursor: 'pointer',
  },
  switchLabel: {
    marginLeft: '8px',
  },
  primaryBtn: {
    width: '100%',
    border: 'none',
    background: '#0d6efd',
    color: '#fff',
    padding: '12px 16px',
    borderRadius: '6px',
    cursor: 'pointer',
    fontWeight: 600,
  },
};

export default SellerDeliverySetting;